// extracted by mini-css-extract-plugin
module.exports = {"green":"styles_green__1Xf6E","yellow":"styles_yellow__3TafS","yellowFill":"styles_yellowFill__3FeJi","red":"styles_red__nfY8O"};